<template>
  <span class="btn-spinner" aria-hidden="true" role="status"></span>
</template>

<script>
export default {
  name: 'ButtonSpinner',
};
</script>

<style lang="scss" scoped>
.btn-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: btn-spin 0.7s linear infinite;
  margin-right: 6px;
  vertical-align: middle;
  flex-shrink: 0;
}

@keyframes btn-spin {
  to { transform: rotate(360deg); }
}
</style>

<style lang="scss">
button:has(.btn-spinner) {
  min-height: 2.5rem;
  min-width: 6rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  box-sizing: border-box;
  flex-shrink: 0;
}
</style>
